import { ParticipantBadgesPayload, ParticipantBadgesUpdate } from '@interfaces/api/participation'
import { axiosPost } from '@services/api/axios'

export const apiParticipantBadgesUpdate = async (participationId: number, payload: ParticipantBadgesPayload) =>
  await axiosPost<ParticipantBadgesPayload, ParticipantBadgesUpdate>(`/external-app-plugin/participations/${participationId.toString()}/issue-badges`, payload)
